// The oversized closing quote of the 2026 brand testimonials, traced from the guidelines.
// It takes the text color, so it can be drawn light grey on white or white on grey.
const WIDTH = 289.67;
const HEIGHT = 295.45;

export const QuoteMark = ({ width = 120, ...props }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={(width * HEIGHT) / WIDTH}
    viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
    fill="currentColor"
    {...props}
  >
    <path d="M3.17 10A10 10 0 0 1 13.17 0H113.17A10 10 0 0 1 123.17 10V136.38C123.17 218.14 82.6 263.77 30.05 294.11A10 10 0 0 1 16.38 290.45L1.34 264.4A10 10 0 0 1 5 250.74C39.64 230.74 61.17 187.95 61.17 145.39V140A10 10 0 0 0 51.17 130H13.17A10 10 0 0 1 3.17 120ZM169.67 10A10 10 0 0 1 179.67 0H279.67A10 10 0 0 1 289.67 10V136.38C289.67 218.14 249.1 263.77 196.55 294.11A10 10 0 0 1 182.88 290.45L167.84 264.4A10 10 0 0 1 171.5 250.74C206.14 230.74 227.67 187.95 227.67 145.39V140A10 10 0 0 0 217.67 130H179.67A10 10 0 0 1 169.67 120Z" />
  </svg>
);
